import { SVGProps } from 'react'

const MarketingIllustration = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="128"
      height="48"
      viewBox="0 0 128 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_15502_3960)">
        <path
          d="M16.8355 44.4637C14.7949 45.1447 12.8852 45.3804 10.9624 44.6339C9.49733 44.0577 7.75769 42.5386 7.36523 41.491C7.63992 41.4518 7.91459 41.3862 8.17622 41.3601C9.27498 41.2422 10.3737 41.072 11.4856 41.0457C12.6497 41.0065 13.7223 41.3862 14.6249 42.1458C15.2527 42.6696 15.8283 43.272 16.4169 43.8613C16.5608 43.9923 16.6523 44.1887 16.8355 44.4637Z"
          fill="white"
        />
        <path
          d="M17.1602 44.0318C17.0687 44.0187 17.0164 44.0187 16.9902 43.9925C15.6821 42.8531 14.4657 41.622 14.1648 39.8146C14.0471 39.0942 14.0602 38.3345 14.1256 37.6011C14.2172 36.6712 14.4395 35.7544 14.6095 34.8376C14.6357 34.7197 14.7142 34.615 14.7796 34.4971C18.0105 36.7629 18.8083 40.5218 17.1602 44.0318Z"
          fill="white"
        />
        <path
          d="M2.64648 34.5352C2.71189 34.4828 2.72497 34.4697 2.73805 34.4697C4.12458 34.509 5.52418 34.509 6.87146 34.8626C8.0487 35.1638 9.00353 35.8317 9.70993 36.8269C10.0761 37.3376 10.4163 37.8745 10.7564 38.3984C10.861 38.5686 10.9133 38.7781 10.9918 38.9746C7.46008 39.7472 3.98069 38.1234 2.64648 34.5352Z"
          fill="white"
        />
        <path
          d="M11.3924 38.6868C11.3401 38.6606 11.2616 38.6475 11.2224 38.6082C10.4376 37.5604 9.7443 36.4602 9.46962 35.1505C9.23416 34.0635 9.43034 33.0288 9.79662 32.0072C10.0975 31.169 10.4506 30.3439 10.7776 29.5188C10.8169 29.4271 10.8823 29.3354 10.9346 29.2568C11.8633 29.8069 12.9097 32.2037 13.0275 33.4872C13.1713 35.2291 12.3734 37.8224 11.3924 38.6868Z"
          fill="white"
        />
        <path
          d="M10.0991 23.7295C11.6164 26.3489 9.92904 31.1948 7.10368 32.3081C7.05136 32.2426 6.97288 32.1902 6.9598 32.1117C6.69819 31.0508 6.4889 29.9899 6.58046 28.8898C6.65895 27.9075 7.01211 27.0168 7.63998 26.2703C8.35942 25.4059 9.1704 24.607 9.92904 23.7819C9.95521 23.7557 10.0075 23.7557 10.0991 23.7295Z"
          fill="white"
        />
        <path
          d="M0.783461 25.4355C2.11766 26.0904 3.54344 26.4834 4.66835 27.4526C5.47933 28.1598 6.01563 29.0373 6.27724 30.0719C6.38189 30.5173 6.49961 30.9626 6.57809 31.4079C6.63041 31.7222 6.63041 32.0366 6.65657 32.3508C5.53166 32.4032 3.42571 31.3293 2.4316 30.1898C1.25436 28.8539 0.770387 27.243 0.783461 25.4355Z"
          fill="white"
        />
        <path
          d="M5.489 25.0195C5.46284 24.9278 5.41051 24.823 5.41051 24.7183C5.38436 23.8014 5.41051 22.8847 5.64596 21.994C5.85525 21.1952 6.24767 20.501 6.81012 19.9117C7.7519 18.9162 8.98148 18.3531 10.0671 17.541C10.4726 18.2352 10.2503 20.1474 9.66164 21.4964C8.98148 23.068 7.08481 24.679 5.489 25.0195Z"
          fill="white"
        />
        <path
          d="M1.11372 17.1025C2.04243 17.8884 2.95806 18.5825 3.78212 19.3814C4.75007 20.3113 5.22097 21.49 5.20789 22.8521C5.20789 23.3367 5.20789 23.8083 5.18173 24.2929C5.16865 24.5286 5.10325 24.7512 5.064 24.987C2.29096 24.4369 -0.181243 19.6302 1.11372 17.1025Z"
          fill="white"
        />
        <path
          d="M9.60388 6.67955C9.55155 6.61406 9.52539 6.60096 9.52539 6.58786C9.57772 4.36135 10.1794 2.40988 12.2853 1.24423C13.0701 0.812024 13.855 0.406011 14.6398 0C14.9538 0.654857 14.6005 2.43607 13.9465 3.62791C13.1356 5.12098 11.1735 6.50928 9.60388 6.67955Z"
          fill="white"
        />
        <path
          d="M3.82335 9.90234C4.63433 10.9501 5.54996 11.8145 6.11242 12.967C6.41327 13.5826 6.55715 14.2374 6.54407 14.9185C6.50483 15.9008 6.29554 16.8307 5.91621 17.7475C3.44401 16.6604 2.25369 12.2467 3.82335 9.90234Z"
          fill="white"
        />
        <path
          d="M11.8983 12.0771C11.7806 15.1939 9.39996 17.6559 6.28683 17.8261C6.27375 17.7737 6.22142 17.7083 6.2345 17.6559C6.56152 15.3904 7.52947 13.5963 9.83161 12.8106C10.381 12.6141 10.9304 12.3784 11.4797 12.1688C11.6105 12.1164 11.7545 12.1164 11.8983 12.0771Z"
          fill="white"
        />
        <path
          d="M14.0343 6.21871C13.6027 9.19139 11.4575 11.2736 8.29205 11.3784C8.26589 11.3391 8.21357 11.2998 8.22669 11.2736C8.46207 10.0688 8.86756 8.92946 9.74398 8.02587C10.2148 7.52827 10.8035 7.18778 11.4444 6.96516C12.2031 6.70325 12.9618 6.45443 13.7335 6.21871C13.7989 6.20561 13.8905 6.21871 14.0343 6.21871Z"
          fill="white"
        />
        <path
          d="M6.29414 3.65625C6.43803 3.70865 6.49035 3.70865 6.51651 3.73484C7.09205 4.57306 7.70682 5.39818 8.21697 6.27569C8.74015 7.16629 8.85792 8.16168 8.60934 9.18327C8.43932 9.8774 8.28234 10.5715 7.92918 11.2002C7.22285 10.9514 6.21566 9.62858 5.79708 8.3581C5.26079 6.73409 5.57472 5.20172 6.29414 3.65625Z"
          fill="white"
        />
        <path
          d="M27.6678 47.5071C27.5501 47.9393 27.2493 48.0309 26.896 47.9916C25.9935 47.9 25.0648 47.8607 24.1753 47.6905C21.8994 47.2714 19.8065 46.3809 17.9098 45.0583C17.7921 44.9796 17.6875 44.8749 17.5566 44.7571C17.6221 44.6654 17.6744 44.5999 17.7659 44.4951C18.0406 44.6522 18.2891 44.7963 18.5508 44.9535C20.382 46.0142 22.3572 46.669 24.4501 46.9178C25.2741 47.0095 26.0982 47.0357 26.9222 47.088C27.2231 47.1143 27.537 47.088 27.6678 47.5071Z"
          fill="white"
        />
        <g clipPath="url(#clip1_15502_3960)">
          <path
            d="M57.668 8C57.668 3.582 64.384 0 72.668 0C80.952 0 87.668 3.582 87.668 8C87.668 12.418 80.952 16 72.668 16C64.384 16 57.668 12.418 57.668 8ZM72.668 20C70.614 20 68.666 19.77 66.886 19.37C64.168 17.332 59.714 16 54.668 16C46.384 16 39.668 19.582 39.668 24C39.668 28.418 46.384 32 54.668 32C62.952 32 69.668 28.418 69.668 24C69.668 23.942 69.654 23.886 69.652 23.828H69.668V28C69.668 32.418 62.952 36 54.668 36C46.384 36 39.668 32.418 39.668 28V32C39.668 36.418 46.384 40 54.668 40C62.952 40 69.668 36.418 69.668 32V36C69.668 40.418 62.952 44 54.668 44C46.384 44 39.668 40.418 39.668 36V40C39.668 44.418 46.384 48 54.668 48C62.952 48 69.668 44.418 69.668 40V39.84C70.638 39.944 71.64 40 72.668 40C80.952 40 87.668 36.418 87.668 32V28C87.668 32.238 81.484 35.698 73.668 35.974V31.974C81.484 31.698 87.668 28.24 87.668 24V20C87.668 24.238 81.484 27.698 73.668 27.974V23.974C81.484 23.698 87.668 20.24 87.668 16V12C87.668 16.418 80.952 20 72.668 20Z"
            fill="white"
          />
        </g>
        <path
          d="M110.5 44.4637C112.541 45.1447 114.451 45.3804 116.374 44.6339C117.839 44.0577 119.578 42.5386 119.971 41.491C119.696 41.4518 119.421 41.3862 119.16 41.3601C118.061 41.2422 116.962 41.072 115.85 41.0457C114.686 41.0065 113.614 41.3862 112.711 42.1458C112.083 42.6696 111.508 43.272 110.919 43.8613C110.775 43.9923 110.684 44.1887 110.5 44.4637Z"
          fill="white"
        />
        <path
          d="M110.176 44.0318C110.267 44.0187 110.32 44.0187 110.346 43.9925C111.654 42.8531 112.87 41.622 113.171 39.8146C113.289 39.0942 113.276 38.3345 113.21 37.6011C113.119 36.6712 112.896 35.7544 112.726 34.8376C112.7 34.7197 112.622 34.615 112.556 34.4971C109.325 36.7629 108.528 40.5218 110.176 44.0318Z"
          fill="white"
        />
        <path
          d="M124.688 34.5352C124.622 34.4828 124.609 34.4697 124.596 34.4697C123.209 34.509 121.81 34.509 120.463 34.8626C119.285 35.1638 118.33 35.8317 117.624 36.8269C117.258 37.3376 116.918 37.8745 116.578 38.3984C116.473 38.5686 116.421 38.7781 116.342 38.9746C119.874 39.7472 123.353 38.1234 124.688 34.5352Z"
          fill="white"
        />
        <path
          d="M115.944 38.6868C115.996 38.6606 116.074 38.6475 116.114 38.6082C116.898 37.5604 117.592 36.4602 117.866 35.1505C118.102 34.0635 117.906 33.0288 117.539 32.0072C117.238 31.169 116.885 30.3439 116.558 29.5188C116.519 29.4271 116.454 29.3354 116.401 29.2568C115.473 29.8069 114.426 32.2037 114.308 33.4872C114.165 35.2291 114.963 37.8224 115.944 38.6868Z"
          fill="white"
        />
        <path
          d="M117.237 23.7295C115.719 26.3489 117.407 31.1948 120.232 32.3081C120.285 32.2426 120.363 32.1902 120.376 32.1117C120.638 31.0508 120.847 29.9899 120.755 28.8898C120.677 27.9075 120.324 27.0168 119.696 26.2703C118.977 25.4059 118.166 24.607 117.407 23.7819C117.381 23.7557 117.328 23.7557 117.237 23.7295Z"
          fill="white"
        />
        <path
          d="M126.551 25.4355C125.216 26.0904 123.791 26.4834 122.666 27.4526C121.855 28.1598 121.318 29.0373 121.057 30.0719C120.952 30.5173 120.834 30.9626 120.756 31.4079C120.704 31.7222 120.704 32.0366 120.677 32.3508C121.802 32.4032 123.908 31.3293 124.902 30.1898C126.08 28.8539 126.564 27.243 126.551 25.4355Z"
          fill="white"
        />
        <path
          d="M121.845 25.0195C121.871 24.9278 121.923 24.823 121.923 24.7183C121.95 23.8014 121.923 22.8847 121.688 21.994C121.479 21.1952 121.086 20.501 120.524 19.9117C119.582 18.9162 118.353 18.3531 117.267 17.541C116.861 18.2352 117.084 20.1474 117.672 21.4964C118.353 23.068 120.249 24.679 121.845 25.0195Z"
          fill="white"
        />
        <path
          d="M126.22 17.1025C125.292 17.8884 124.376 18.5825 123.552 19.3814C122.584 20.3113 122.113 21.49 122.126 22.8521C122.126 23.3367 122.126 23.8083 122.152 24.2929C122.165 24.5286 122.231 24.7512 122.27 24.987C125.043 24.4369 127.515 19.6302 126.22 17.1025Z"
          fill="white"
        />
        <path
          d="M117.732 6.67955C117.784 6.61406 117.811 6.60096 117.811 6.58786C117.758 4.36135 117.157 2.40988 115.051 1.24423C114.266 0.812024 113.481 0.406011 112.696 0C112.382 0.654857 112.735 2.43607 113.389 3.62791C114.2 5.12098 116.162 6.50928 117.732 6.67955Z"
          fill="white"
        />
        <path
          d="M123.513 9.90234C122.702 10.9501 121.786 11.8145 121.224 12.967C120.923 13.5826 120.779 14.2374 120.792 14.9185C120.831 15.9008 121.04 16.8307 121.42 17.7475C123.892 16.6604 125.082 12.2467 123.513 9.90234Z"
          fill="white"
        />
        <path
          d="M115.438 12.0771C115.555 15.1939 117.936 17.6559 121.049 17.8261C121.062 17.7737 121.115 17.7083 121.101 17.6559C120.774 15.3904 119.806 13.5963 117.504 12.8106C116.955 12.6141 116.406 12.3784 115.856 12.1688C115.725 12.1164 115.581 12.1164 115.438 12.0771Z"
          fill="white"
        />
        <path
          d="M113.3 6.21871C113.731 9.19139 115.876 11.2736 119.042 11.3784C119.068 11.3391 119.12 11.2998 119.107 11.2736C118.872 10.0688 118.466 8.92946 117.59 8.02587C117.119 7.52827 116.531 7.18778 115.89 6.96516C115.131 6.70325 114.372 6.45443 113.6 6.21871C113.535 6.20561 113.444 6.21871 113.3 6.21871Z"
          fill="white"
        />
        <path
          d="M121.042 3.65625C120.898 3.70865 120.846 3.70865 120.819 3.73484C120.244 4.57306 119.629 5.39818 119.119 6.27569C118.596 7.16629 118.478 8.16168 118.727 9.18327C118.897 9.8774 119.054 10.5715 119.407 11.2002C120.113 10.9514 121.12 9.62858 121.539 8.3581C122.075 6.73409 121.761 5.20172 121.042 3.65625Z"
          fill="white"
        />
        <path
          d="M99.6681 47.5071C99.7858 47.9393 100.087 48.0309 100.44 47.9916C101.342 47.9 102.271 47.8607 103.161 47.6905C105.437 47.2714 107.529 46.3809 109.426 45.0583C109.544 44.9796 109.648 44.8749 109.779 44.7571C109.714 44.6654 109.662 44.5999 109.57 44.4951C109.295 44.6522 109.047 44.7963 108.785 44.9535C106.954 46.0142 104.979 46.669 102.886 46.9178C102.062 47.0095 101.238 47.0357 100.414 47.088C100.113 47.1143 99.7989 47.088 99.6681 47.5071Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_15502_3960">
          <rect
            width="127.314"
            height="48"
            fill="white"
            transform="translate(0.00976562)"
          />
        </clipPath>
        <clipPath id="clip1_15502_3960">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(39.668)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MarketingIllustration
